/**
 * Conifguration related to the enterprise partner
 */

export const ENTERPRISE_ENVIRONMENT =
  process.env.REACT_APP_ENTERPRISE_ENVIRONMENT || 'qa';
